'use strict'
/**
 * 硬件编辑器代逐行运行的业务逻辑
 *
 *window.Interpreter 在public/index 通过 <script src="/blockly/code/acorn_interpreter.js"></script>引入
 *
 * @author linhui.zhang
 */

import Blockly from '@/assets/blockly/renderers/index.js'
import bus from '@/utils/bus'
// import {debounce} from 'lodash'
//实训接口
// import BLOCK from '@/axios/trainingCenter/AiEditor/blocks.js'
// import Interpreter from '../../../public/blockly/code/acorn_interpreter.js'
export const BlocklyInterpreter = {
  data() {
    return {
      // newBlocksType: null, //自建积木类型
      // newBlocks: null, //自建积木类工具箱的积木;
      // renameDefBlockObj: {}, //缓存重命名的自定义积木l
      outPut: '',
      highlightPause: false,
      latestCode: '',
      myInterpreter: null, //编译对象
      hasMoreCode: true,
      mockCode: `
      n = 1
      for count in range(2):
      n = n+1
      print(n)
      `,
    }
  },
  watch: {},
  created() {
    //控制积木分布执行
  },
  mounted() {
    let _this = this
    setTimeout(() => {
      // Load the interpreter now, and upon future changes.
      this.generateCodeAndLoadIntoInterpreter()
      this.workspace.addChangeListener(function(event) {
        if (!(event instanceof Blockly.Events.Ui)) {
          // Something changed. Parser needs to be reloaded.
          _this.generateCodeAndLoadIntoInterpreter()
        }
      })
    }, 500)

    bus.$on('stepHighlightBlock', (blockId) => {
      _this.highlightBlock(blockId)
    })
  },
  beforeDestroy() {
    bus.$off('stepHighlightBlock')
  },
  methods: {
    getPythonCode() {
      let code,
        reg = /[\n\r]$/,
        generator = Blockly.Python
      if (
        this.checkAllGeneratorFunctionsDefined(generator) &&
        this.workspaceIsVisible
      ) {
        code = generator.workspaceToCode(this.workspace)
      } else if (!this.workspaceIsVisible) {
        code = this.pythonEditorCode
        if (!reg.test(code)) {
          code = code + '\n'
        }
      }
      console.log('code', code)
      this.$store.state.blocklyHome.codeText = code

      //过滤python脚本
      this.pythonEditorCode=  this.pythonEditorCodeFilter(code)
      // this.pythonEditorCode = code //获取python脚本;

      return code
    },
    pythonEditorCodeFilter(code) {
      let arr = code.split('\n')
      let pythonCode = ''

      arr= arr.filter((code) => {
        return !/highlightBlock\(/.test(code)
      })
      pythonCode = arr.join('\n')
      console.log('pythonCode--------\n', pythonCode)
     return pythonCode

    },
    stepPythonCode() {
      let arr = this.latestCode.split('\n')

      for (let i = 0; i < arr.length - 1; i++) {
        let code = arr[i]
        if (/highlightBlock\(/.test(code)) {
          setTimeout(() => {
            code = code.trim()
            code = `"this.${code}"`
            // console.log(code)
            eval(code)
            return
          }, 1000)
        }
      }
    },
    stepRunHandle() {
      let _this = this
      // let func = eval(`this.highlightBlock('%QwZ9rDNnFs!xC7vnCU{');`)
      //  func(this);
      // new Function(`this.highlightBlock('72yVfgywiX}+^Fjz+CAV')`)
      // this.highlightBlock('72yVfgywiX}+^Fjz+CAV')
      let myCode = this.getPythonCode()
      this.stepPythonCode()

      return
      if (!this.myInterpreter) {
        let myCode = this.getPythonCode()
        // First statement of this code.
        // Clear the program output.
        this.resetStepUi(true)
        // js 解析器插件
        this.myInterpreter = new window.Interpreter(
          // this.mockCode,
          this.latestCode,
          this.initApi
        )
        setTimeout(function() {
          _this.highlightPause = true
          _this.stepRunHandle()
        }, 1)
        return
      }
      this.highlightPause = false
      do {
        try {
          this.hasMoreCode = this.myInterpreter.step()
          console.log('this.hasMoreCode ', this.hasMoreCode)
        } finally {
          if (!this.hasMoreCode) {
            this.outPut += '\n\n<< Program complete >>'
            this.myInterpreter = null
            this.resetStepUi(false)
          }
        }
      } while (this.hasMoreCode && !this.highlightPause)
    },

    initApi(interpreter, scope) {
      let _this = this
      // Add an API function for the alert() block, generated for "text_print" blocks.
      interpreter.setProperty(
        scope,
        'alert',
        interpreter.createNativeFunction(function(text) {
          text = text ? text.toString() : ''
          this.outPut += '\n' + text
          console.log('text', text)
        })
      )

      // Add an API function for highlighting blocks.
      var wrapper = function(id) {
        id = id ? id.toString() : ''
        console.log('id--------\n', id)
        return interpreter.createPrimitive(_this.highlightBlock(id))
      }
      interpreter.setProperty(
        scope,
        'highlightBlock',
        interpreter.createNativeFunction(wrapper)
      )
    }, // initApi end
    highlightBlock(id) {
      this.workspace.highlightBlock(id)
      this.highlightPause = true
      // this.highlightPause = true
      if (this.hasMoreCode) {
        setTimeout(() => {
          // this.stepRunHandle()
        }, 300)
      }
    },
    resetStepUi(clearOutput) {
      this.workspace.highlightBlock(null)
      this.highlightPause = false
    },
    //盛鼎代码生成器的方法
    generateCodeAndLoadIntoInterpreter() {
      Blockly.Python.STATEMENT_PREFIX = 'highlightBlock(%1);\n'
      Blockly.Python.addReservedWords('highlightBlock')
      this.latestCode = Blockly.Python.workspaceToCode(this.workspace)
      // this.latestCode = Blockly.Python.workspaceToCode(this.workspace)
      this.latestCode = this.latestCode.replace(/^\s+/, '')

      this.resetStepUi(true)
    },
  },
}
